export const ItemTypes = {
  ELEMENT: "moving_element"
};
